(() => {
  const normalize = (value = '') => value.toLocaleLowerCase('sv-SE').trim();

  function showPanel(root, focus = false) {
    const panels = [...root.querySelectorAll('[data-school-panel]')];
    if (!panels.length) return;

    const requestedId = decodeURIComponent(window.location.hash.slice(1));
    const panel = panels.find((item) => item.id === requestedId) || panels[0];

    panels.forEach((item) => { item.hidden = item !== panel; });
    root.querySelectorAll('[data-school-link]').forEach((link) => {
      const current = link.hash === `#${panel.id}`;
      if (current) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });

    if (!focus) return;
    panel.querySelector('h2')?.focus({ preventScroll: true });
    panel.scrollIntoView({ block: 'start', behavior: 'smooth' });
    if (window.matchMedia('(max-width: 749px)').matches) {
      const menu = root.querySelector('[data-school-menu]');
      if (menu) menu.open = false;
    }
  }

  function filterFaq(root, category) {
    const activeButton = root.querySelector('[data-da-faq-filter].is-active, [data-da-faq-filter][aria-pressed="true"]');
    const selectedCategory = category || activeButton?.dataset.daFaqFilter || 'all';
    const query = normalize(root.querySelector('[data-da-faq-search]')?.value);
    let visibleCount = 0;

    root.querySelectorAll('[data-da-faq-filter]').forEach((button) => {
      const active = button.dataset.daFaqFilter === selectedCategory;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });

    root.querySelectorAll('[data-da-faq-item]').forEach((item) => {
      const categoryMatches = selectedCategory === 'all' || item.dataset.category === selectedCategory;
      const textMatches = !query || normalize(item.textContent).includes(query);
      const visible = categoryMatches && textMatches;
      item.hidden = !visible;
      if (!visible) item.open = false;
      if (visible) visibleCount += 1;
    });

    const status = root.querySelector('[data-faq-count]');
    if (status) status.textContent = visibleCount === 1 ? '1 fråga visas' : `${visibleCount} frågor visas`;
    const empty = root.querySelector('[data-faq-empty]');
    if (empty) empty.hidden = visibleCount !== 0;
  }

  function initialize(scope = document) {
    scope.querySelectorAll('[data-da-school]').forEach((root) => {
      showPanel(root);
      if (window.matchMedia('(max-width: 749px)').matches) {
        const menu = root.querySelector('[data-school-menu]');
        if (menu) menu.open = false;
      }
    });
    scope.querySelectorAll('[data-da-faq-hub]').forEach((root) => filterFaq(root));
  }

  if (!window.daSchoolListenersInstalled) {
    window.daSchoolListenersInstalled = true;

    document.addEventListener('click', (event) => {
      const filterButton = event.target.closest('[data-da-faq-filter]');
      if (filterButton) {
        const faqRoot = filterButton.closest('[data-da-faq-hub]');
        if (faqRoot) filterFaq(faqRoot, filterButton.dataset.daFaqFilter);
      }

      const schoolLink = event.target.closest('[data-da-school] a[data-school-link][href^="#"]');
      if (!schoolLink) return;
      const schoolRoot = schoolLink.closest('[data-da-school]');
      const matchingPanel = schoolRoot.querySelector(`[data-school-panel]${schoolLink.hash}`);
      if (!matchingPanel) return;
      event.preventDefault();
      if (window.location.hash !== schoolLink.hash) history.pushState(null, '', schoolLink.hash);
      showPanel(schoolRoot, true);
    });

    document.addEventListener('input', (event) => {
      if (!event.target.matches('[data-da-faq-search]')) return;
      const faqRoot = event.target.closest('[data-da-faq-hub]');
      if (faqRoot) filterFaq(faqRoot);
    });

    window.addEventListener('hashchange', () => {
      document.querySelectorAll('[data-da-school]').forEach((root) => showPanel(root, true));
    });
    window.addEventListener('popstate', () => {
      document.querySelectorAll('[data-da-school]').forEach((root) => showPanel(root, true));
    });
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const panel = event.target.closest('[data-school-panel]');
      if (!panel) return;
      history.replaceState(null, '', `#${panel.id}`);
      showPanel(panel.closest('[data-da-school]'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
})();
